import React from "react";
import { Modal } from "flowbite-react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

interface InviteModalProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  icon?: React.ReactNode;
  footerChildren?: React.ReactNode;
  size?: "sm" | "md" | "lg";
}

const InviteModal = ({ children, footerChildren, isOpen, onClose, title, icon, size = "md" }: InviteModalProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <Modal
          show={isOpen}
          onClose={onClose}
          size={size}
          position="center"
          popup
          className="!backdrop-blur-sm"
          theme={{
            root: {
              base: "fixed top-0 right-0 left-0 z-50 h-screen flex justify-center items-center bg-gray-900/50",
              show: {
                on: "flex bg-gray-900/50",
                off: "hidden"
              }
            },
            content: {
              base: "relative h-full md:h-auto",
              inner: "relative rounded-xl bg-white shadow flex flex-col max-h-[90vh]"
            }
          }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ duration: 0.2 }}
          >
            <Modal.Header className="border-b border-gray-200/80 bg-white rounded-t-lg px-6 py-4">
              <div className="flex justify-between items-center w-full">
                <h3 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
                  {icon}
                  {title}
                </h3>
              </div>
            </Modal.Header>
            <Modal.Body className="bg-white p-6">
              {children}
            </Modal.Body>

            <Modal.Footer className="border-t border-gray-200/80 bg-white rounded-b-lg px-6 py-4">
              <div className="flex justify-end gap-3">
                {footerChildren}
              </div>
            </Modal.Footer>
          </motion.div>
        </Modal>
      )}
    </AnimatePresence>
  );
};

export default InviteModal;